exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".qrCode[data-v-58483e61] {\n  color: #1890ff;\n  font-size: 14px;\n}\n.top[data-v-58483e61] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.operate[data-v-58483e61] {\n  color: #1890ff;\n  font-size: 14px;\n  margin: 0 20px;\n  cursor: pointer;\n}\n", ""]);

// exports
